<div
  class="bd-object-search-results-header"
  [ngClass]="{ 'bd-multi-select-mode': isSelectionMode }"
  *transloco="
    let t;
    scope: 'featureSearch';
    prefix: 'featureSearch.searchResults'
  "
>
  <div class="flex items-center gap-2">
    <div data-id="search-results-count" class="bd-label-regular">
      {{
        t('itemsCount', {
          totalSearchResultsCount: totalSearchResultsCount,
        })
      }}
    </div>
    <p-divider layout="vertical"></p-divider>
    @if (showSelectAllButton) {
      <p-button
        data-id="select-all-objects-button"
        (onClick)="onSelectAllClick()"
        [label]="t('selectAllObjects')"
        [link]="true"
        styleClass="bd-no-capitalize"
        [disabled]="selectAllDisabled"
      ></p-button>
    }
  </div>

  @if (isSelectionMode) {
    <div
      data-id="search-results-header-actions"
      class="flex gap-1 items-center"
    >
      <p-button
        data-id="cancel-select-button"
        [attr.aria-label]="t('unselectAll')"
        (onClick)="onCancel()"
        icon="ui-close"
        [text]="true"
        [pTooltip]="t('unselectAll')"
        [tooltipPosition]="'top'"
      />
      <div data-id="search-results-selected-title" class="bd-label-regular">
        {{
          t('selectedCount', {
            count: numberOfSelectedItems,
          })
        }}
      </div>
      <p-divider class="bd-actions-divider" layout="vertical"></p-divider>

      @for (action of actions; track action.labelKey) {
        <div *transloco="let tGlobal" class="inline-block">
          @let actionState =
            action.subject && action.actionKey
              ? (action.subject | actionState: action.actionKey | async)
              : null;
          @let roleTooltip =
            action.subject && action.actionKey
              ? tGlobal(
                  (action.subject | getNoAccessKey: action.actionKey | async) ??
                    ''
                )
              : '';
          @let tooltip =
            roleTooltip || (action.tooltipKey ? t(action.tooltipKey) : '');
          @let tooltipDisabled =
            actionState === 'accessible' && !action.tooltipKey;
          @let buttonDisabled = actionState === 'disabled' || action.disabled;
          @if (actionState !== 'hidden') {
            <p-button
              class="bd-action-button"
              [attr.data-id]="
                'search-results-header-actions-' + action.labelKey
              "
              [label]="action.labelKey ? t(action.labelKey) : ''"
              (onClick)="action.onClick($event)"
              [text]="action.type === 'tertiary'"
              [outlined]="action.type === 'secondary'"
              [loading]="action?.loading$ | async"
              tooltipPosition="bottom"
              [pTooltip]="tooltip"
              [tooltipDisabled]="tooltipDisabled"
              [disabled]="buttonDisabled"
            ></p-button>
          }
        </div>
      }
    </div>
  }
</div>
